import React from 'react';
import './ToolButton.css';

export default ({ toggled = false, glyph, value, onClick }) => (
  <button
    className={toggled ? 'ToolButton toggled' : 'ToolButton'}
    onClick={onClick}
  >
    <span className={glyph} />
    <span className={value ? 'caption' : ''}>
      {value}
    </span>
  </button>
);



// WEBPACK FOOTER //
// ./src/components/ToolButton/ToolButton.jsx